
(function(){
  var SESSION_KEY='tsume_session_token_v1';
  var ITEMS_KEY='tsume_selected_items_v1';
  var ORDER_KEY='tsume_selected_order_v1';
  var MODE_KEY='tsume_mode_v1';
  var HEARTBEAT_MS=60000;
  var POLL_MS=15000;
  var CAMPAIGN_POLL_MS=60000;

  document.addEventListener('DOMContentLoaded',function(){
    var root=document.querySelector('#TsumePicker');
    if(!root)return;

    var sessionUrl=root.dataset.sessionUrl;
    var holdUrl=root.dataset.holdUrl;
    var checkoutUrl=root.dataset.checkoutUrl;
    var CAMPAIGN_NAME=(root.dataset.campaignName||'このキャンペーン').trim()||'このキャンペーン';
    var PERIOD_LABEL=(root.dataset.periodLabel||'').trim();

    var availabilityEl=root.querySelector('[data-tsume-availability]');
    var campaignActive=false;
    var campaignPhase='UNKNOWN';

    var BASE_COUNT=Math.max(2,Number(root.dataset.baseCount)||3);
    var BASE_TOTAL=Math.max(1,Number(root.dataset.baseTotal)||13800);
    var MAX_PRICE=Math.max(1,Number(root.dataset.maxPrice)||6980);
    var UPSELL_ENABLED=root.dataset.upsellEnabled==='true';
    var UPSELL_EXTRA_COUNT=Math.max(1,Number(root.dataset.upsellExtraCount)||2);
    var UPSELL_TOTAL=Math.max(BASE_TOTAL,Number(root.dataset.upsellTotal)||21800);
    var UPSELL_COUNT=BASE_COUNT+UPSELL_EXTRA_COUNT;
    var BASE_EYEBROW=root.dataset.baseEyebrow||BASE_COUNT+'点 '+formatYen(BASE_TOTAL);
    var BASE_TITLE=root.dataset.baseTitle||'好きな古着を'+BASE_COUNT+'点選ぶ';
    var BASE_LEAD=root.dataset.baseLead||'対象商品から'+BASE_COUNT+'点。選んだ商品は一時的にキープされます。';

    function getCards(){return Array.prototype.slice.call(root.querySelectorAll('[data-tsume-card]'));}
    var countEl=root.querySelector('[data-tsume-count]');
    var denominatorEl=root.querySelector('[data-tsume-denominator]');
    var confirmBtn=root.querySelector('[data-tsume-confirm]');
    var returnThreeBtn=root.querySelector('[data-tsume-return-three]');
    var toastEl=root.querySelector('[data-tsume-toast]');

    var eyebrowEl=root.querySelector('[data-tsume-eyebrow]');
    var titleEl=root.querySelector('[data-tsume-title]');
    var leadEl=root.querySelector('[data-tsume-lead]');
    var modeNoteEl=root.querySelector('[data-tsume-mode-note]');

    var review=root.querySelector('[data-tsume-review]');
    var reviewItems=root.querySelector('[data-tsume-review-items]');
    var reviewEyebrow=root.querySelector('[data-tsume-review-eyebrow]');
    var reviewTitle=root.querySelector('[data-tsume-review-title]');
    var regularTotalEl=root.querySelector('[data-tsume-regular-total]');
    var promoLabelEl=root.querySelector('[data-tsume-promo-label]');
    var promoTotalEl=root.querySelector('[data-tsume-promo-total]');
    var savingEl=root.querySelector('[data-tsume-saving]');
    var reviewNote=root.querySelector('[data-tsume-review-note]');
    var reviewBack=root.querySelector('[data-tsume-review-back]');
    var buyBtn=root.querySelector('[data-tsume-buy]');

    var upsell=root.querySelector('[data-tsume-upsell]');
    var upsellAccept=root.querySelector('[data-tsume-upsell-accept]');
    var upsellDecline=root.querySelector('[data-tsume-upsell-decline]');

    var sessionToken=sessionStorage.getItem(SESSION_KEY)||'';
    var selectedItems=loadJson(ITEMS_KEY,{});
    var selectedOrder=loadJson(ORDER_KEY,[]);
    var mode=sessionStorage.getItem(MODE_KEY)==='UPSELL'?'UPSELL':'BASE';

    var baseOwned=new Set();
    var upsellOwned=new Set();
    var heldOther=new Set();
    var toastTimer=null;
    var booted=false;
    var checkoutBusy=false;

    function loadJson(key,fallback){
      try{
        var raw=sessionStorage.getItem(key);
        if(!raw)return fallback;
        var parsed=JSON.parse(raw);
        return parsed||fallback;
      }catch(e){return fallback}
    }

    function saveSelectionState(){
      try{
        sessionStorage.setItem(ITEMS_KEY,JSON.stringify(selectedItems));
        sessionStorage.setItem(ORDER_KEY,JSON.stringify(selectedOrder));
        sessionStorage.setItem(MODE_KEY,mode);
      }catch(e){}
    }

    function allOwned(){
      var set=new Set();
      baseOwned.forEach(function(id){set.add(id)});
      upsellOwned.forEach(function(id){set.add(id)});
      return set;
    }

    function totalOwnedCount(){
      return baseOwned.size+upsellOwned.size;
    }

    function showToast(message){
      if(!toastEl)return;
      toastEl.textContent=message;
      toastEl.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer=setTimeout(function(){toastEl.classList.remove('is-show')},2800);
    }

    function formatYen(value){
      return '¥'+new Intl.NumberFormat('ja-JP').format(Number(value)||0);
    }

    function post(url,body){
      return fetch(url,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(body)
      }).then(function(res){
        return res.json().catch(function(){return {}}).then(function(data){
          return {res:res,data:data};
        });
      });
    }

    function getJson(url){
      return fetch(url,{
        method:'GET',
        headers:{'Accept':'application/json'}
      }).then(function(res){
        return res.json().catch(function(){return {}}).then(function(data){
          return {res:res,data:data};
        });
      });
    }

    function formatJapaneseDate(value){
      var m=String(value||'').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if(!m)return '';
      var month=Number(m[2]);
      var day=Number(m[3]);
      var date=new Date(value+'T00:00:00+09:00');
      if(Number.isNaN(date.getTime()))return month+'月'+day+'日';
      var weekdays=['日','月','火','水','木','金','土'];
      return month+'月'+day+'日（'+weekdays[date.getDay()]+'）';
    }

    function setCampaignUi(active,phase,campaign){
      campaignActive=active===true;
      campaignPhase=phase||'UNKNOWN';
      root.classList.toggle('is-campaign-inactive',!campaignActive);

      if(!availabilityEl)return;

      if(campaignActive){
        availabilityEl.hidden=true;
        availabilityEl.textContent='';
        return;
      }

      availabilityEl.hidden=false;
      if(campaignPhase==='BEFORE'){
        var startLabel=formatJapaneseDate(campaign&&campaign.startDate);
        availabilityEl.textContent=startLabel
          ? CAMPAIGN_NAME+'は'+startLabel+'から開催します。'
          : CAMPAIGN_NAME+'は近日開催します。';
      }else if(campaignPhase==='AFTER'){
        availabilityEl.textContent=CAMPAIGN_NAME+'は終了しました。';
      }else if(campaignPhase==='DISABLED'){
        availabilityEl.textContent=CAMPAIGN_NAME+'は現在停止中です。';
      }else if(campaignPhase==='INVALID_SCHEDULE'){
        availabilityEl.textContent='開催期間の設定を確認してください。';
      }else{
        availabilityEl.textContent='現在、キャンペーンの開催状況を確認しています。';
      }
    }

    function refreshCampaignStatus(){
      return getJson(holdUrl+'?action=config').then(function(result){
        if(!result.res.ok||!result.data||!result.data.campaign){
          setCampaignUi(false,'UNKNOWN',null);
          return false;
        }

        var campaign=result.data.campaign;
        setCampaignUi(campaign.active===true,campaign.phase||'UNKNOWN',campaign);
        return campaignActive;
      }).catch(function(){
        setCampaignUi(false,'UNKNOWN',null);
        return false;
      });
    }

    function createSession(){
      return post(sessionUrl,{}).then(function(result){
        if(!result.res.ok||!result.data||!result.data.sessionToken)throw new Error('SESSION_CREATE_FAILED');

        sessionToken=result.data.sessionToken;
        sessionStorage.setItem(SESSION_KEY,sessionToken);

        baseOwned=new Set();
        upsellOwned=new Set();
        heldOther=new Set();
        selectedItems={};
        selectedOrder=[];
        mode='BASE';
        saveSelectionState();

        return sessionToken;
      });
    }

    function ensureSession(){
      if(!sessionToken)return createSession();

      return post(holdUrl+'?action=heartbeat',{sessionToken:sessionToken}).then(function(result){
        if(!result.res.ok||result.data.code==='SESSION_EXPIRED'||result.data.code==='INVALID_SESSION'){
          sessionStorage.removeItem(SESSION_KEY);
          sessionToken='';
          return createSession();
        }
      });
    }

    function visibleCardById(id){
      var cards=getCards();
      for(var i=0;i<cards.length;i++){
        if(cards[i].dataset.variantId===id)return cards[i];
      }
      return null;
    }

    function rememberCard(card){
      if(!card)return;

      var id=card.dataset.variantId;
      if(!id)return;

      var img=card.querySelector('.tsume-card__image');

      selectedItems[id]={
        variantId:id,
        productHandle:card.dataset.productHandle||'',
        title:card.dataset.productTitle||'',
        variantTitle:card.dataset.variantTitle||'',
        priceJpy:Number(card.dataset.priceJpy)||0,
        imageUrl:img?(img.currentSrc||img.src||''):''
      };

      if(selectedOrder.indexOf(id)===-1)selectedOrder.push(id);
      saveSelectionState();
    }

    function forgetItem(id){
      delete selectedItems[id];
      selectedOrder=selectedOrder.filter(function(x){return x!==id});
      saveSelectionState();
    }

    function normalizeStoredSelection(){
      var owned=allOwned();

      Object.keys(selectedItems).forEach(function(id){
        if(!owned.has(id))delete selectedItems[id];
      });

      selectedOrder=selectedOrder.filter(function(id){return owned.has(id)});

      owned.forEach(function(id){
        if(selectedOrder.indexOf(id)===-1)selectedOrder.push(id);
        var card=visibleCardById(id);
        if(card)rememberCard(card);
      });

      saveSelectionState();
    }

    function renderHeaderAndTray(){
      if(mode==='UPSELL'){
        if(eyebrowEl)eyebrowEl.textContent=UPSELL_COUNT+'点 '+formatYen(UPSELL_TOTAL);
        if(titleEl)titleEl.textContent='あと'+UPSELL_EXTRA_COUNT+'点だけ選ぶ';
        if(leadEl)leadEl.textContent='最初の'+BASE_COUNT+'点はそのまま。追加する'+UPSELL_EXTRA_COUNT+'点を選んでください。';
        if(modeNoteEl)modeNoteEl.hidden=false;

        if(countEl)countEl.textContent=String(totalOwnedCount());
        if(denominatorEl)denominatorEl.textContent=' / '+UPSELL_COUNT;
        if(confirmBtn){
          confirmBtn.textContent='この'+UPSELL_COUNT+'点を確認する';
          confirmBtn.disabled=!(baseOwned.size===BASE_COUNT&&upsellOwned.size===UPSELL_EXTRA_COUNT);
        }
        if(returnThreeBtn)returnThreeBtn.hidden=false;
      }else{
        if(eyebrowEl)eyebrowEl.textContent=BASE_EYEBROW;
        if(titleEl)titleEl.textContent=BASE_TITLE;
        if(leadEl)leadEl.textContent=BASE_LEAD;
        if(modeNoteEl)modeNoteEl.hidden=true;

        if(countEl)countEl.textContent=String(baseOwned.size);
        if(denominatorEl)denominatorEl.textContent=' / '+BASE_COUNT;
        if(confirmBtn){
          confirmBtn.textContent='この'+BASE_COUNT+'点を確認する';
          confirmBtn.disabled=baseOwned.size!==BASE_COUNT;
        }
        if(returnThreeBtn)returnThreeBtn.hidden=true;
      }
    }

    function renderCards(){
      getCards().forEach(function(card){
        var id=card.dataset.variantId;
        var status=card.querySelector('[data-tsume-status]');
        var base=baseOwned.has(id);
        var extra=upsellOwned.has(id);
        var other=heldOther.has(id);

        card.classList.toggle('is-selected',base||extra);
        card.classList.toggle('is-base-locked',mode==='UPSELL'&&base);
        card.classList.toggle('is-upsell-selected',extra);
        card.classList.toggle('is-held-other',other);
        card.setAttribute('aria-pressed',(base||extra)?'true':'false');

        if(other){
          card.setAttribute('aria-disabled','true');
          if(status)status.textContent='他のお客様が選択中';
        }else if(mode==='UPSELL'&&base){
          card.removeAttribute('aria-disabled');
          if(status)status.textContent='最初の'+BASE_COUNT+'点';
        }else if(extra){
          card.removeAttribute('aria-disabled');
          if(status)status.textContent='追加';
        }else if(base){
          card.removeAttribute('aria-disabled');
          if(status)status.textContent='選択中';
        }else{
          card.removeAttribute('aria-disabled');
          if(status)status.textContent='';
        }
      });
    }

    function render(){
      renderCards();
      renderHeaderAndTray();
      normalizeStoredSelection();
    }

    function syncActive(){
      if(!sessionToken||document.hidden)return Promise.resolve();

      return fetch(holdUrl+'?action=active&sessionToken='+encodeURIComponent(sessionToken),{method:'GET'})
        .then(function(res){
          return res.json().then(function(data){return {res:res,data:data}});
        })
        .then(function(result){
          if(!result.res.ok)return;

          var nextBase=new Set();
          var nextUpsell=new Set();
          var nextOther=new Set();

          (result.data.holds||[]).forEach(function(hold){
            var id=hold.variant_id||hold.variantId;
            if(!id)return;

            if(hold.state==='HELD_BY_ME'){
              if(hold.selection_type==='UPSELL')nextUpsell.add(id);
              else nextBase.add(id);
            }else if(hold.state==='HELD_BY_OTHER'){
              nextOther.add(id);
            }
          });

          baseOwned=nextBase;
          upsellOwned=nextUpsell;
          heldOther=nextOther;

          if((!UPSELL_ENABLED||baseOwned.size!==BASE_COUNT)&&mode==='UPSELL')mode='BASE';

          render();
        })
        .catch(function(){});
    }

    function renew(){
      if(!sessionToken||totalOwnedCount()===0||document.hidden)return Promise.resolve();

      return post(holdUrl+'?action=heartbeat',{sessionToken:sessionToken})
        .then(function(result){
          if(result.res.ok)return;

          if(result.data.code==='SESSION_EXPIRED'||result.data.code==='INVALID_SESSION'){
            sessionStorage.removeItem(SESSION_KEY);
            sessionToken='';
            baseOwned=new Set();
            upsellOwned=new Set();
            heldOther=new Set();
            selectedItems={};
            selectedOrder=[];
            mode='BASE';
            saveSelectionState();
            closeAllModals();
            render();

            return createSession().then(function(){
              showToast('選択時間が終了しました。もう一度選んでください。');
              return syncActive();
            });
          }
        })
        .catch(function(){});
    }

    function acquire(card,selectionType){
      if(!campaignActive){
        showToast('現在はキャンペーン開催期間外です。');
        return Promise.resolve();
      }
      if(selectionType==='BASE'&&baseOwned.size>=BASE_COUNT){
        showToast(BASE_COUNT+'点選択済みです。入れ替える場合は選択中の商品を外してください。');
        return Promise.resolve();
      }

      if(selectionType==='UPSELL'&&upsellOwned.size>=UPSELL_EXTRA_COUNT){
        showToast('追加できるのは'+UPSELL_EXTRA_COUNT+'点までです。');
        return Promise.resolve();
      }

      var variantId=card.dataset.variantId;
      var productHandle=card.dataset.productHandle;

      if(!variantId||!productHandle)return Promise.resolve();

      card.classList.add('is-busy');

      return post(holdUrl+'?action=acquire',{
        sessionToken:sessionToken,
        variantId:variantId,
        productHandle:productHandle,
        selectionType:selectionType
      }).then(function(result){
        if(result.res.ok&&result.data&&result.data.ok){
          if(selectionType==='UPSELL')upsellOwned.add(variantId);
          else baseOwned.add(variantId);

          heldOther.delete(variantId);
          rememberCard(card);
          render();

          if(selectionType==='BASE'&&baseOwned.size===BASE_COUNT)showToast(BASE_COUNT+'点選択できました。');
          if(selectionType==='UPSELL'&&upsellOwned.size===UPSELL_EXTRA_COUNT)showToast(UPSELL_COUNT+'点そろいました。');

          return;
        }

        if(result.data.code==='HELD_BY_OTHER'){
          heldOther.add(variantId);
          render();
          showToast('この商品は他のお客様が選択中です。');
          return;
        }

        if(result.data.code==='SOLD_OUT'){
          heldOther.add(variantId);
          render();
          showToast('この商品は売り切れました。');
          return;
        }

        if(result.data.code==='SESSION_EXPIRED'||result.data.code==='INVALID_SESSION'){
          sessionStorage.removeItem(SESSION_KEY);
          sessionToken='';
          return createSession().then(function(){
            showToast('選択セッションを更新しました。もう一度選んでください。');
          });
        }

        showToast('選択できませんでした。もう一度お試しください。');
      }).catch(function(){
        showToast('通信に失敗しました。もう一度お試しください。');
      }).finally(function(){
        card.classList.remove('is-busy');
      });
    }

    function releaseVariant(variantId){
      return post(holdUrl+'?action=release',{
        sessionToken:sessionToken,
        variantId:variantId
      });
    }

    function releaseCard(card,type){
      var variantId=card.dataset.variantId;
      if(!variantId)return Promise.resolve();

      card.classList.add('is-busy');

      return releaseVariant(variantId)
        .then(function(result){
          if(result.res.ok&&result.data&&result.data.ok){
            if(type==='UPSELL')upsellOwned.delete(variantId);
            else baseOwned.delete(variantId);
            forgetItem(variantId);
            render();
            return;
          }
          return syncActive();
        })
        .catch(function(){
          showToast('選択解除に失敗しました。もう一度お試しください。');
        })
        .finally(function(){
          card.classList.remove('is-busy');
        });
    }

    function releaseAllUpsell(){
      var ids=Array.from(upsellOwned);

      if(ids.length===0){
        mode='BASE';
        saveSelectionState();
        render();
        openReview('THREE');
        return Promise.resolve();
      }

      return Promise.all(ids.map(function(id){
        return releaseVariant(id).catch(function(){return null});
      })).then(function(){
        ids.forEach(function(id){
          upsellOwned.delete(id);
          forgetItem(id);
        });

        mode='BASE';
        saveSelectionState();
        render();
        closeAllModals();
        openReview('THREE');
      }).catch(function(){
        showToast('3点セットに戻せませんでした。もう一度お試しください。');
      });
    }

    function selectedForReview(reviewMode){
      var wanted=reviewMode==='FIVE'?allOwned():baseOwned;
      var ids=selectedOrder.filter(function(id){return wanted.has(id)});

      wanted.forEach(function(id){
        if(ids.indexOf(id)===-1)ids.push(id);
      });

      return ids.map(function(id){
        if(!selectedItems[id]){
          var card=visibleCardById(id);
          if(card)rememberCard(card);
        }
        return selectedItems[id]||null;
      }).filter(Boolean);
    }

    function buildReview(reviewMode){
      var items=selectedForReview(reviewMode);
      var expected=reviewMode==='FIVE'?UPSELL_COUNT:BASE_COUNT;
      var promoTotal=reviewMode==='FIVE'?UPSELL_TOTAL:BASE_TOTAL;

      if(items.length!==expected){
        showToast('選択商品の情報を確認できませんでした。ページを再読み込みしてください。');
        return false;
      }

      reviewItems.innerHTML='';
      reviewItems.classList.toggle('is-five',reviewMode==='FIVE');

      var regularTotal=0;

      items.forEach(function(item){
        regularTotal+=Number(item.priceJpy)||0;

        var wrap=document.createElement('div');
        wrap.className='tsume-review-item';

        var media=document.createElement('span');
        media.className='tsume-review-item__media';

        if(item.imageUrl){
          var image=document.createElement('img');
          image.className='tsume-review-item__image';
          image.src=item.imageUrl;
          image.alt=item.title||'選択商品';
          media.appendChild(image);
        }

        var title=document.createElement('span');
        title.className='tsume-review-item__title';
        title.textContent=item.title||'選択商品';

        var price=document.createElement('span');
        price.className='tsume-review-item__price';
        price.textContent=formatYen(item.priceJpy);

        wrap.appendChild(media);
        wrap.appendChild(title);
        wrap.appendChild(price);
        reviewItems.appendChild(wrap);
      });

      review.dataset.mode=reviewMode;
      regularTotalEl.textContent=formatYen(regularTotal);

      if(reviewMode==='FIVE'){
        reviewEyebrow.textContent='選んだ'+UPSELL_COUNT+'点';
        reviewTitle.textContent='この'+UPSELL_COUNT+'点で'+formatYen(UPSELL_TOTAL);
        promoLabelEl.textContent=UPSELL_COUNT+'点セット';
        promoTotalEl.textContent=formatYen(UPSELL_TOTAL);
        reviewNote.textContent='※'+UPSELL_COUNT+'点セットは'+formatYen(UPSELL_TOTAL)+'。北海道・沖縄・離島は通常の送料規定に準じます。';
        buyBtn.textContent='この'+UPSELL_COUNT+'点で購入する';
      }else{
        reviewEyebrow.textContent='選んだ'+BASE_COUNT+'点';
        reviewTitle.textContent='この'+BASE_COUNT+'点で'+formatYen(BASE_TOTAL);
        promoLabelEl.textContent=BASE_COUNT+'点セット';
        promoTotalEl.textContent=formatYen(BASE_TOTAL);
        reviewNote.textContent='※商品の通常価格にかかわらず、'+BASE_COUNT+'点セット価格は'+formatYen(BASE_TOTAL)+'です。';
        buyBtn.textContent='この'+BASE_COUNT+'点で購入する';
      }

      var saving=regularTotal-promoTotal;

      if(saving>0){
        savingEl.hidden=false;
        savingEl.textContent=new Intl.NumberFormat('ja-JP').format(saving)+'円お得';
      }else{
        savingEl.hidden=true;
        savingEl.textContent='';
      }

      return true;
    }

    function openReview(reviewMode){
      if(reviewMode==='FIVE'){
        if(!(UPSELL_ENABLED&&baseOwned.size===BASE_COUNT&&upsellOwned.size===UPSELL_EXTRA_COUNT))return;
      }else{
        if(baseOwned.size!==BASE_COUNT)return;
      }

      if(!buildReview(reviewMode))return;

      closeUpsell();
      review.classList.add('is-open');
      review.setAttribute('aria-hidden','false');
      document.body.classList.add('tsume-modal-open');
    }

    function closeReview(){
      review.classList.remove('is-open');
      review.setAttribute('aria-hidden','true');
      if(!upsell.classList.contains('is-open'))document.body.classList.remove('tsume-modal-open');
    }

    function openUpsell(){
      closeReview();
      upsell.classList.add('is-open');
      upsell.setAttribute('aria-hidden','false');
      document.body.classList.add('tsume-modal-open');
    }

    function closeUpsell(){
      upsell.classList.remove('is-open');
      upsell.setAttribute('aria-hidden','true');
      if(!review.classList.contains('is-open'))document.body.classList.remove('tsume-modal-open');
    }

    function closeAllModals(){
      closeReview();
      closeUpsell();
      document.body.classList.remove('tsume-modal-open');
    }

    function enterUpsellMode(){
      mode='UPSELL';
      saveSelectionState();
      closeAllModals();
      render();
      showToast('あと'+UPSELL_EXTRA_COUNT+'点選んでください。');
    }

    function createRequestToken(){
      if(window.crypto&&typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID();
      return 'tsume-'+Date.now()+'-'+Math.random().toString(36).slice(2);
    }

    function startCheckout(checkoutMode){
      if(checkoutBusy)return Promise.resolve();
      if(!campaignActive){
        showToast('現在はキャンペーン開催期間外です。');
        return Promise.resolve();
      }

      if(checkoutMode==='THREE'&&baseOwned.size!==BASE_COUNT){
        showToast(BASE_COUNT+'点の選択状態を確認してください。');
        return Promise.resolve();
      }

      if(checkoutMode==='FIVE'&&!(UPSELL_ENABLED&&baseOwned.size===BASE_COUNT&&upsellOwned.size===UPSELL_EXTRA_COUNT)){
        showToast(UPSELL_COUNT+'点の選択状態を確認してください。');
        return Promise.resolve();
      }

      checkoutBusy=true;
      buyBtn.disabled=true;
      upsellDecline.disabled=true;
      upsellAccept.disabled=true;

      var requestToken=createRequestToken();

      return post(checkoutUrl,{
        sessionToken:sessionToken,
        requestToken:requestToken,
        mode:checkoutMode
      }).then(function(result){
        if(result.res.ok&&result.data&&result.data.ok&&result.data.invoiceUrl){
          window.location.href=result.data.invoiceUrl;
          return;
        }

        checkoutBusy=false;
        buyBtn.disabled=false;
        upsellDecline.disabled=false;
        upsellAccept.disabled=false;

        if(result.data&&result.data.code==='REPLACE_ITEMS_REQUIRED'){
          closeAllModals();
          return syncActive().then(function(){
            showToast('売り切れた商品があります。別の商品を選び直してください。');
          });
        }

        if(result.data&&result.data.code==='CHECKOUT_IN_PROGRESS'){
          showToast('購入画面を準備しています。少し待ってからもう一度お試しください。');
          return;
        }

        showToast('購入画面を作成できませんでした。もう一度お試しください。');
      }).catch(function(){
        checkoutBusy=false;
        buyBtn.disabled=false;
        upsellDecline.disabled=false;
        upsellAccept.disabled=false;
        showToast('通信に失敗しました。もう一度お試しください。');
      });
    }

    root.addEventListener('click',function(event){
      var card=event.target.closest('[data-tsume-card]');
      if(!card||!root.contains(card))return;
      if(!campaignActive){
        showToast('現在はキャンペーン開催期間外です。');
        return;
      }

      var id=card.dataset.variantId;
      if(!id||card.classList.contains('is-busy'))return;

      if(heldOther.has(id)){
        showToast('この商品は他のお客様が選択中です。');
        return;
      }

      if(mode==='UPSELL'){
        if(baseOwned.has(id)){
          showToast('最初に選んだ'+BASE_COUNT+'点は固定されています。');
          return;
        }

        if(upsellOwned.has(id)){
          releaseCard(card,'UPSELL');
          return;
        }

        acquire(card,'UPSELL');
        return;
      }

      if(baseOwned.has(id)){
        releaseCard(card,'BASE');
      }else{
        acquire(card,'BASE');
      }
    });

    root.addEventListener('tsume:cards-added',function(){
      render();
      if(booted)syncActive();
    });

    if(confirmBtn){
      confirmBtn.addEventListener('click',function(){
        if(mode==='UPSELL'){
          openReview('FIVE');
        }else{
          openReview('THREE');
        }
      });
    }

    if(reviewBack){
      reviewBack.addEventListener('click',function(){
        closeReview();
      });
    }

    if(buyBtn){
      buyBtn.addEventListener('click',function(){
        var reviewMode=review.dataset.mode||'THREE';

        if(reviewMode==='FIVE'){
          startCheckout('FIVE');
        }else if(UPSELL_ENABLED){
          openUpsell();
        }else{
          startCheckout('THREE');
        }
      });
    }

    if(upsellAccept){
      upsellAccept.addEventListener('click',function(){
        if(checkoutBusy)return;
        enterUpsellMode();
      });
    }

    if(upsellDecline){
      upsellDecline.addEventListener('click',function(){
        startCheckout('THREE');
      });
    }

    if(returnThreeBtn){
      returnThreeBtn.addEventListener('click',function(){
        if(checkoutBusy)return;
        releaseAllUpsell();
      });
    }

    document.addEventListener('keydown',function(event){
      if(event.key!=='Escape')return;

      if(upsell.classList.contains('is-open')){
        closeUpsell();
        openReview('THREE');
      }else if(review.classList.contains('is-open')){
        closeReview();
      }
    });

    document.addEventListener('visibilitychange',function(){
      if(!document.hidden){
        refreshCampaignStatus().then(function(active){
          if(active){
            if(!booted)bootSelection();
            else{
              renew();
              syncActive();
            }
          }
        });
      }
    });

    function bootSelection(){
      if(booted||!campaignActive)return Promise.resolve();

      return ensureSession()
        .then(function(){return syncActive()})
        .then(function(){booted=true})
        .catch(function(){
          showToast('商品選択を開始できませんでした。ページを再読み込みしてください。');
        });
    }

    refreshCampaignStatus()
      .then(function(active){
        if(active)return bootSelection();
      });

    setInterval(function(){if(booted&&campaignActive)syncActive()},POLL_MS);
    setInterval(function(){if(booted&&campaignActive)renew()},HEARTBEAT_MS);
    setInterval(function(){
      refreshCampaignStatus().then(function(active){
        if(active&&!booted)bootSelection();
        if(!active)closeAllModals();
      });
    },CAMPAIGN_POLL_MS);
  });
})();
